import React from 'react';

export const ProfilePublishPage = React.lazy(() => import('./ProfilePublishPage'));
